export class Slot {
    dueDate: Date;
    driveIds: string[];
}